var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92383 7.41992C6.17676 7.41992 6.38867 7.32422 6.57324 7.12598L11.4678 2.12891C11.6182 1.97168 11.7002 1.78027 11.7002 1.55469C11.7002 1.08984 11.3379 0.727539 10.8799 0.727539C10.6611 0.727539 10.4492 0.823242 10.2852 0.980469L5.93066 5.45801L1.5625 0.980469C1.40527 0.823242 1.19336 0.727539 0.967773 0.727539C0.509766 0.727539 0.147461 1.08984 0.147461 1.55469C0.147461 1.78027 0.229492 1.97168 0.386719 2.12891L5.27441 7.13281C5.47266 7.32422 5.67773 7.41992 5.92383 7.41992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.c37e2b132bf128b8907be29b0b1e3b29.svg";
export { ForwardRef as ReactComponent };